import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subject } from "rxjs";
import { Product, ProductResponse } from '../../../models/Product';
import { User } from '../../../models/User';
import { ProductService } from '../../../services/product.service';
import { AuthService } from '../../../services/auth.service';


@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent {
  @Input('products') products:Product[];  //linked to parent 'products', will initially be null until products are loaded
  @Input('user') user:User;  //needed to toggle the edit button for admin users that are logged in.
  // products:Product[];  //products filtered by category
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  category:string = null;
  

  constructor(
    private route:ActivatedRoute,
    private productService:ProductService,
    private authService:AuthService
  ) { }

  ngOnInit(){
    console.log('pl - init');
  }

  ngOnChanges(){
    console.log('pl - onchanges with this.products', this.products);
  }
  //This is necessary, otherwise single-page reloads of product-list component will cause old subscriptions to duplicate upon each ngInit.
  // **better way would have been for product.component to manage the products / user, and pass them in to product-list as inputs.
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}




//Unused Code


    // console.log('product-list calling getproducts()');
    

    // this.productService.products$.subscribe(products => {
    //   console.log('product-list received products');
    // });


    // this.productService.getProducts().subscribe(products => {
    //   console.log('product-list, inside getProducts.subscribe()');
    //   console.log('products: ', products);
    //   this.products = products;
  
    // });

    // this.productService.getProducts((products) => {
    //   console.log('product-list received products: ', products);
    //   // this.products = products;  
    // });

    // this.productService.getProducts((products) => {
    //   console.log('products: ', products);      
    //   this.products = products;
    // });

    
    // this.productService.getProducts().subscribe((response:ProductResponse) => {
    //   this.products = Product.fromJsonList(response.products); //convert service observable to product[]
    //   console.log('pl - imported products: ', this.products);
    // });

    // console.log('product-list observed new category', this.category);
      // console.log('product-list getting products from productservice');


      // //products were loaded by product.component.ts
      // this.productService.getProductsByCategory(this.category).subscribe(products => {  
      //   this.products = products;
      // });
      // this.productService.product$.subscribe((products) => {
      //   console.log('observed loaded products', products);
      //   this.products = products;
      // });

      // //**this part needs refactoring.  productService.products should be a behaviorSubject.
      // //request products from productService, filtered by latest category
      // this.productService.getProducts().subscribe(products => {
      //   //filter the products to those in category
      //   if (this.category != null) {
      //     let filteredProducts = products.filter((product) => {
      //       return product.category == this.category;
      //     });
      //     this.products = filteredProducts;
      //   } else {
      //     this.products = products;
      //   }
      // },
      //   err => {
      //     console.log('Error occured getting products', err)
      //   },
      //   () => {
      //     console.log('Completed');
      //   }
      // );

            //moved to products component, and feeds into here as input
      // //products were loaded by product.component.ts
      // this.productService.product$
      // .takeUntil(this.ngUnsubscribe)
      // .subscribe((products) => {
      //   // console.log('p-list: observed change in products');
      //   // console.log('p-list observed change in products with category', this.category);
      //   let filteredProducts = this.productService.getProductsByCategory(this.category);
      //   let activeProducts = filteredProducts.filter((product) => {
      //       return product.active == true;
      //   });
        
      //   // console.log('p-detail: filteredProduct by sku', filteredProduct);  
      //   this.products = activeProducts;       
      //   });
        
      

        //no longer needed, since we're using inputs
  // ngOnChanges(changes: SimpleChanges){
  //   console.log('pl: onChanges[\'products\']', changes['products']);
  //   console.log('products', this.products);
  //   console.log('user', this.user);
  //   //observe changes to user until ngUnsubscribe
  //   //use route params to set local properties
  //   this.route.params.subscribe((params: Params) => {
  //     // console.log('new params');
  //     this.category = params["category"];

  //     //observe changes in the user that is logged in
  //     this.authService.user$
  //     .takeUntil(this.ngUnsubscribe)
  //     .subscribe((user) => {
  //       // console.log('p-list: observed change in user', user);
  //       this.user = user;
  //     });
  //   });

  // }


// WEBPACK FOOTER //
// ./src/app/components/products/product-list/product-list.component.ts